const doc = [({"da":({"js":({"admin":({"reimbursement_attachments":({"expandable_content":({"attachment":"Bilag"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;